const processResponse = async response => {
  if (!response) {
    return {};
  } // handling for fetch api statuses that should error


  if (response.status >= 400) {
    throw Error(`Bad request: ${response.status}`);
  } // need to check for the `.json()`, as consumers may not use the fetch api,
  // and cypress test environment do not have a json method for stubbed responses


  if (typeof response.json === 'function') {
    return response.json();
  } // handle unlikely possibility that a test environment may not have a JSON global


  if (typeof response === 'string' && typeof JSON?.parse === 'function') {
    return JSON.parse(response);
  }

  return response;
};

export default processResponse;
//# sourceMappingURL=processResponse.js.map